import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { SharedModule } from "../shared/shared.module";
import { AddressSelectorComponent } from "./address-selector.component";
import { AutoCompleteComponent } from "./auto-complete/auto-complete.component";
import { ViewAddressComponent } from "./view-address/view-address.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    SharedModule,
    TextFieldModule
  ],
  exports: [
    AddressSelectorComponent
  ],
  declarations: [
    AddressSelectorComponent,
    AutoCompleteComponent,
    ViewAddressComponent
  ]
})
export class AddressSelectorModule { }
